import Vue from 'vue'

import Vuex from 'vuex'
Vue.use(Vuex);

import VueRouter from 'vue-router'
Vue.use(VueRouter);

import router from './router/router'
import store from './store/store'
//import sync from './utils/vuexRouterSync'
//sync(store, router);

//register all global filters
import registerGlobalVueFilters from './utils/vueFilters'
registerGlobalVueFilters(Vue);

//disable annoying tooltip
Vue.config.productionTip = true;

import App from './App.vue';

new Vue({
    el: '#migrol-tankstellensuche',
    render: h => h(App),
    store,
    router
});
